import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Search, Hash, User, Flame } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const mediaUrl = (src) => (src && src.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${src}` : src || "");

export const useSuggestions = (q, enabled) => {
  const [data, setData] = useState(null);
  const timer = useRef();
  useEffect(() => {
    if (!enabled) return;
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      axios.get(`${API}/search/suggest`, { params: { q } }).then((r) => setData(r.data)).catch(() => {});
    }, q ? 180 : 0);
    return () => clearTimeout(timer.current);
  }, [q, enabled]);
  return data;
};

export const SearchSuggestions = ({ data, q, onStory, onTerm, className = "" }) => {
  if (!data) return null;
  const empty = !data.stories.length && !data.topics.length && !data.people.length;
  return (
    <div data-testid="search-suggestions" className={`bg-[#0a0a0a] border border-white/15 shadow-2xl text-left ${className}`}>
      {empty ? (
        <p className="px-4 py-4 text-sm text-neutral-500">No matches yet — press Enter to search everything.</p>
      ) : (
        <>
          {!!data.stories.length && (
            <div className="py-2">
              <p className="px-4 pb-1 text-[10px] uppercase tracking-[0.25em] font-bold text-neutral-600 flex items-center gap-1.5">{q ? <Search size={10} /> : <Flame size={10} />} {q ? "Stories" : "Popular right now"}</p>
              {data.stories.map((s) => (
                <button key={s.id} type="button" data-testid={`suggest-story-${s.id}`} onMouseDown={(e) => e.preventDefault()} onClick={() => onStory(s)}
                  className="w-full flex items-center gap-3 px-4 py-2 text-left hover:bg-white/[0.06] transition-colors">
                  <img src={mediaUrl(s.image)} alt="" className="w-10 h-10 object-cover grayscale shrink-0" />
                  <span className="min-w-0">
                    <span className="block text-sm text-white leading-snug line-clamp-1">{s.title}</span>
                    <span className="block text-[10px] uppercase tracking-wider text-[#E30613] font-bold">{s.network}</span>
                  </span>
                </button>
              ))}
            </div>
          )}
          {(!!data.topics.length || !!data.people.length) && (
            <div className="border-t border-white/10 px-4 py-3 flex flex-wrap gap-2">
              {data.topics.map((t) => (
                <button key={`t-${t}`} type="button" data-testid={`suggest-topic-${t.toLowerCase().replace(/\s+/g, "-")}`} onMouseDown={(e) => e.preventDefault()} onClick={() => onTerm(t)}
                  className="inline-flex items-center gap-1 text-[11px] uppercase tracking-wider font-bold text-neutral-300 border border-white/15 px-2.5 py-1 hover:border-[#E30613] hover:text-white transition-colors"><Hash size={10} /> {t}</button>
              ))}
              {data.people.map((p) => (
                <button key={`p-${p}`} type="button" data-testid={`suggest-person-${p.toLowerCase().replace(/\s+/g, "-")}`} onMouseDown={(e) => e.preventDefault()} onClick={() => onTerm(p)}
                  className="inline-flex items-center gap-1 text-[11px] uppercase tracking-wider font-bold text-neutral-300 border border-white/15 px-2.5 py-1 hover:border-[#E30613] hover:text-white transition-colors"><User size={10} /> {p}</button>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
};
